// extracted by mini-css-extract-plugin
module.exports = {"PageAccessDeniedWrapper":"PageAccessDenied_PageAccessDeniedWrapper__2aI5_"};